import axios from "axios";
import { Config } from "../../data/config";
import moment from "moment";
import { setForm } from "../actions/form";
export const SET_TIMESLOTS = "TIMESLOTS | SET_TIMESLOTS";
export const RESET_TIMESLOTS = "TIMESLOTS | RESET_TIMESLOTS";
export const SET_TIMESLOTS_TYPE = "TIMESLOTS | SET_TIMESLOTS_TYPE";

export function fetchTimeslots(promotion) {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${Config.frontApiUrl}/onboarding/promo/timeslots/${promotion}`)
        .then(response => {

          const data = response.data.map(slot => {
            const from = moment(slot.timeslot_from);
            const to = moment(slot.timeslot_to);

            slot["timeslot_day_desc"] = from.format("ddd, MMM D");
            slot["timeslot_from_time"] = from.format("h:mmA");
            slot["timeslot_to_time"] = to.format("h:mmA");

            return slot;
          });
          dispatch(setForm({ timeslotType: 'promo' }));
          dispatch(setTimeSlots(data));
          // const data = [];
          resolve(data.length > 0);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
}
export function fetchCustomTimeSlots(id_building) {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${Config.frontApiUrl}/onboarding/timeslots/${id_building}`)
        .then(response => {
          const data = response.data.map(slot => {
            const from = moment(slot.timeslot_from);
            const to = moment(slot.timeslot_to);

            slot["timeslot_day_desc"] = from.format("ddd, MMM D");
            slot["timeslot_from_time"] = from.format("h:mmA");
            slot["timeslot_to_time"] = to.format("h:mmA");

            return slot;
          });
          // const data = [];
          dispatch(setForm({ timeslotType: 'custom' }));
          dispatch(setTimeSlots(data));
          resolve(data.length > 0);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
}

export function setTimeSlots(data) {
  return { type: SET_TIMESLOTS, payload: data };
}

export function resetTimeSlots() {
  return { type: RESET_TIMESLOTS };
}



// WEBPACK FOOTER //
// ./src/store/actions/timeslots.js